import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IMOption } from './typing';

@Component({
  selector: 'm-download',
  template: `
    <button nz-dropdown class="m-download-button" [nzDropdownMenu]="mOptions.length ? downloadMenu : null">
      <i nz-icon class="m-download-icon">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="组件" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="3-1文字模式-（选中单元格）" transform="translate(-1391.000000, -12.000000)" fill="#595959">
              <g id="-mockplus-" transform="translate(56.000000, 0.000000)">
                <g id="编组-2" transform="translate(1328.000000, 8.000000)">
                  <g id="-mockplus-" transform="translate(7.000000, 4.000000)">
                    <g id="Icon/Line/save备份" transform="translate(2.000000, 2.000000)">
                      <path
                        d="M0.961573133,5.73745189 L0.961,11.304 L11.538,11.304 L11.5384269,5.73745189 L12.5,5.73745189 L12.5,12.2662619 L0,12.2662619 L0,5.73745189 L0.961573133,5.73745189 Z M6.73078658,0 L6.73,7.736 L8.98306857,5.48364118 L9.66313253,6.16340472 L6.25000002,9.57653726 L2.83693094,6.16346819 L3.51677976,5.48343157 L5.769,7.736 L5.76921345,0 L6.73078658,0 Z"
                        id="形状结合"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </i>
      <i nz-icon class="m-download-dropdown-icon" *ngIf="mOptions.length" nzType="caret-down" nzTheme="outline"></i>
    </button>
    <nz-dropdown-menu #downloadMenu="nzDropdownMenu">
      <ul nz-menu>
        <li
          nz-menu-item
          *ngFor="let item of mOptions"
          [nzDisabled]="item.disabled ? item.disabled() : false"
          (click)="onOperationClick(item)"
        >
          {{ item.text }}
        </li>
      </ul>
    </nz-dropdown-menu>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MDownloadComponent {
  @Input() mOptions: IMOption[] = [];

  onOperationClick(operation: IMOption): void {
    if (operation.disabled && operation.disabled()) {
      return;
    }
    if (operation.onClick) {
      operation.onClick();
    }
  }
}
